/** Consecutive nav items with the same `group` share a heading. */
export function groupItems(items) {
  const groups = [];
  for (const item of items) {
    const last = groups[groups.length - 1];
    if (last && last.heading === item.group) last.items.push(item);
    else groups.push({ heading: item.group, items: [item] });
  }
  return groups;
}
